var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp"},[_c('v-btn',{staticClass:"btn",attrs:{"color":"primary"},domProps:{"innerHTML":_vm._s(_vm.settings.label)},on:{"click":_vm.doAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }